<div class="modal-dialog-centered">
  <div class="modal-content">
      <div class="modal-header">
          <h5 class="modal-title" id="aboutModalLabel">About</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="activeModal.dismiss('Cross click')"> </button>
      </div>
      <div class="modal-body">
        <div class="about-fix">
          Copyright &copy; 2011-{{yearNow}} 
          <br>
          <strong>Database: </strong> {{appInfo.database}} <strong> ({{env}}) </strong> 
          <br>
          <strong> Version: </strong> {{appInfo.version}} <br> <span class="d-inline-block"><strong>Last Updated: </strong> {{appInfo.lastUpdated}}</span>
        </div>
      </div>
      <div class="modal-footer">
          <!-- <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="activeModal.dismiss('Cross click')">Close</button> -->
      </div>

  </div>
</div>